module.exports = __webpack_public_path__ + "static/img/trainingListBg.ed155733.png";